import fetchWithTimeout from "../../utils/fetchWithTimeout";

export async function addToCart(formData) {
  formData.append("action", "custom_add_to_cart");
  formData.append("nonce", cartVars.nonce);

  return await fetchWithTimeout(
    cartVars.ajaxUrl,
    {
      method: "POST",
      body: formData,
    },
    5000,
    "addToCart"
  );
}
